type ApiErrorOptions = ErrorOptions & {
  info?: Error[];
  status?: number;
};

export default class CustomError extends Error {
  status?: number;
  info?: Error[];
  constructor(message: string, options: ApiErrorOptions) {
    super(message, options);
    this.status = options.status;
    this.info = options.info;
  }
}
